import React, {Component} from 'react'
import {
  StyleSheet,
  View,
  Dimensions,
  ScrollView,
  TextInput,
  ActivityIndicator,
} from 'react-native'
import {Text, Input, ButtonGroup, Button} from 'react-native-elements'
import MonacoEditor from 'react-monaco-editor'

import cloneDeep from 'lodash/cloneDeep'
const WIDTH = Dimensions.get('window').width
const VIEW_WIDTH = WIDTH / 1.5
const HEIGHT = Dimensions.get('window').height
const INPUT_WIDTH = VIEW_WIDTH / 2.5

class InputType extends Component {
  constructor (props) {
    super(props)
  }

  loadEditorView = () => {
    switch (this.props.type) {
      case 0:
        return (
          <TextInput
            style={styles.textInputStyle}
            value={this.props.value}
            placeholder='Text'
            onChangeText={this.props.onBodyChange}
            multiline={true}
            numberOfLines={10}
          />
        )
      case 1:
        return (
          <TextInput
            style={styles.inputStyle}
            value={this.props.value}
            placeholder='Paste link here'
            onChangeText={this.props.onBodyChange}
          />
        )
      case 2:
        return (
          <View style={styles.inputViewStyle}>
            <TextInput
              style={styles.urlInputStyle}
              placeholder={'Paste link or click select'}
              onChangeText={this.props.onBodyChange}
              textContentType={'URL'}
              value={this.props.value}
            />
            <Button
              buttonStyle={styles.createButtonStyle}
              title={'SELECT'}
              titleStyle={styles.createButtonTitleStyle}
              icon={{
                name: 'link',
                type: 'font-awesome-5',
                size: 15,
                color: 'white',
              }}
              containerStyle={styles.selectButtonStyle}
              onPress={this.props.onSelectFileForTimePoint}
            />
          </View>
        )
      case 3:
        return (
          <View style={styles.inputStyle}>
            <MonacoEditor
              width={INPUT_WIDTH}
              height={INPUT_WIDTH / 2}
              language='javascript'
              theme='vs-dark'
              value={this.props.value}
              options={{
                selectOnLineNumbers: true,
                formatOnPaste: true,
                readOnly: false,
                minimap: {
                  enabled: false,
                },
              }}
              onChange={this.props.onBodyChange}
              editorDidMount={(editor, monaco) => {
                editor.focus()
                setTimeout(function () {
                  editor.getAction('editor.action.formatDocument').run()
                }, 300)
              }}
            />
          </View>
        )

      default:
        break
    }
  }

  onTypeChange = type => {
    this.props.onBodyAndTypeChange(type, '')
  }

  render () {
    const buttons = ['Text', 'Link', 'File', 'Code']
    const {type} = this.props
    return (
      <View>
        <ButtonGroup
          onPress={this.onTypeChange}
          selectedIndex={type}
          buttons={buttons}
          containerStyle={styles.buttonGroupContainerStyle}
          buttonStyle={styles.buttonGroupButtonStyle}
          selectedButtonStyle={styles.buttonGroupSelectedButtonStyle}
          buttonContainerStyle={styles.buttonGroupButtonContainerStyle}
          selectedTextStyle={styles.buttonGroupSelectedTextStyle}
          innerBorderStyle={styles.buttonGroupInnerBorderStyle}
        />
        {this.loadEditorView()}
      </View>
    )
  }
}

const styles = StyleSheet.create({
  inputViewStyle: {
    width: INPUT_WIDTH,
    margin: 15,
    flexDirection: 'row',
  },
  urlInputStyle: {
    flex: 0.6,
  },
  selectButtonStyle: {
    flex: 0.4,
  },
  createButtonTitleStyle: {
    color: 'white',
    fontSize: 15,
  },
  createButtonStyle: {
    height: 30,
    backgroundColor: '#007599',
    borderRadius: 2,
    marginHorizontal: 10,
  },
  buttonGroupInnerBorderStyle: {
    width: 0,
  },
  buttonGroupSelectedTextStyle: {
    color: '#007599',
  },
  buttonGroupButtonContainerStyle: {
    width: 50,
  },
  buttonGroupSelectedButtonStyle: {
    backgroundColor: 'white',
  },
  buttonGroupButtonStyle: {
    width: 50,
    margin: 0,
    padding: 0,
  },
  buttonGroupContainerStyle: {
    height: 20,
    borderWidth: 0,
    margin: 0,
    padding: 0,
  },
  inputStyle: {
    width: INPUT_WIDTH,
    margin: 15,
  },
  textInputStyle: {
    width: INPUT_WIDTH,
    margin: 15,
    borderWidth: 1,
    borderColor: 'grey',
  },
})

export default InputType
